var types = {
  UPDATE_FIELD_CHANGE: "UPDATE_FIELD_CHANGE",
  UPDATE_BIZ_ROUTE_INDEX: "UPDATE_BIZ_ROUTE_INDEX",
  UPDATE_BIZ_ROUTE_TABLE: "UPDATE_BIZ_ROUTE_TABLE",
  UPDATE_NAV_ROUTE_TABLE: "UPDATE_NAV_ROUTE_TABLE",
  UPDATE_IMG_NAV_ROUTE_TABLE: "UPDATE_IMG_NAV_ROUTE_TABLE",
  UPDATE_SUBNAV_INDEX: "UPDATE_SUBNAV_INDEX",
  UPDATE_BUSI_CODE: "UPDATE_BUSI_CODE",
  UPDATE_USER_TYPE: "UPDATE_USER_TYPE",
  UPDATE_COMPONENT_BUTTON_CLICK: "UPDATE_COMPONENT_BUTTON_CLICK",
  UPDATE_MODULE_BUTTON_CLICK: "UPDATE_MODULE_BUTTON_CLICK",
  UPDATE_MODULE_CUSTOMIZE_BUTTON_CLICK: "UPDATE_MODULE_CUSTOMIZE_BUTTON_CLICK",
  UPDATE_MODULE_ZDCUSTOMIZE_BUTTON_CLICK: "UPDATE_MODULE_ZDCUSTOMIZE_BUTTON_CLICK",
  UPDATE_MODULE_BENIFICUSTOMIZE_BUTTON_CLICK: "UPDATE_MODULE_BENIFICUSTOMIZE_BUTTON_CLICK",
  UPDATE_MODULE_DOWNLOAD_BUTTON_CLICK: "UPDATE_MODULE_DOWNLOAD_BUTTON_CLICK",
  UPDATE_MODULE_IMPORT_BUTTON_CLICK: "UPDATE_MODULE_IMPORT_BUTTON_CLICK",
  UPDATE_IMAGE_NODE_SET: "UPDATE_IMAGE_NODE_SET",
  UPDATE_QUEUE_WAIT_NUM: "UPDATE_QUEUE_WAIT_NUM",
  UPDATE_IS_RECORD: "UPDATE_IS_RECORD",
  UPDATE_IS_LOGIN: "UPDATE_IS_LOGIN",
  UPDATE_HAS_PASSWORD: "UPDATE_HAS_PASSWORD",
  UPDATE_CARD_DATA: "UPDATE_CARD_DATA",
  UPDATE_OLD_BIZ_DATA: "UPDATE_OLD_BIZ_DATA",
  UPDATE_LEFT_CLICK_STATE: "UPDATE_LEFT_CLICK_STATE",
  UPDATE_REJECT_REMARK: "UPDATE_REJECT_REMARK",
  UPDATE_OPEN_CURRENT_NUM: "UPDATE_OPEN_CURRENT_NUM",
  UPDATE_IS_EXTERAL: "UPDATE_IS_EXTERAL",
  UPDATE_IMAGE_COLLECT_OBJ: "UPDATE_IMAGE_COLLECT_OBJ",
  UPDATE_IS_JUMPTO_IAMGE: "UPDATE_IS_JUMPTO_IAMGE",
  UPDATE_CUSTOMER_CHECK_RESULT: "UPDATE_CUSTOMER_CHECK_RESULT",
  UPDATE_ROUTE_TABLE_FLAG: "UPDATE_ROUTE_TABLE_FLAG",
  UPDATE_REJECT_TOGGLED: "UPDATE_REJECT_TOGGLED",
  UPDATE_PRE_BIZ_ROUTE_INDEX: "UPDATE_PRE_BIZ_ROUTE_INDEX",
  UPDATA_IMAGE_NAV_SUBMIT_NEED: "UPDATA_IMAGE_NAV_SUBMIT_NEED",
  UPDATA_IMAGE_NAV_SUBMIT_SUCCESS: "UPDATA_IMAGE_NAV_SUBMIT_SUCCESS",
  UPDATE_SHOW_BIZINFO: "UPDATE_SHOW_BIZINFO",
  UPDATE_TRANS_BIZ_DATA: "UPDATE_TRANS_BIZ_DATA",
  UPDATE_LOADING: "UPDATE_LOADING",
  UPDATE_TOKEN: "UPDATE_TOKEN",
  UPDATE_USER_INFO: "UPDATE_USER_INFO",
  UPDATE_APPT_SN: "UPDATE_APPT_SN",
  UPDATE_B_SNO: "UPDATE_B_SNO",
  UPDATE_OPEN_ACCTTYPE: "UPDATE_OPEN_ACCTTYPE",
  UPDATE_APPT_STATUS: "UPDATE_APPT_STATUS",
  UPDATE_CUSTOMER_INFO: "UPDATE_CUSTOMER_INFO",
  UPDATE_EDIT_AUTH: "UPDATE_EDIT_AUTH",
  UPDATE_WITNESS_AUTH: "UPDATE_WITNESS_AUTH",
  UPDATE_CHECK_AUTH: "UPDATE_CHECK_AUTH",
  UPDATE_CAN_CLEAN_DATA: "UPDATE_CAN_CLEAN_DATA",
  UPDATE_MOBILE_LOGIN: "UPDATE_MOBILE_LOGIN",
  UPDATE_LAST_MOBILE_LOGIN: "UPDATE_LAST_MOBILE_LOGIN",
  UPDATE_PAGE_RELOAD: "UPDATE_PAGE_RELOAD" };

var plugin = {
  install: function install(Vue) {
    Vue.types = types;

    Vue.prototype.$types = types;
  },

  $types: types
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/vuex/mutation-types.js
// module id = 124
// module chunks = 2